import { render, staticRenderFns } from "./FormMessaging.vue?vue&type=template&id=985c4d50&scoped=true&"
import script from "./FormMessaging.vue?vue&type=script&lang=js&"
export * from "./FormMessaging.vue?vue&type=script&lang=js&"
import style0 from "./FormMessaging.vue?vue&type=style&index=0&id=985c4d50&scoped=true&lang=css&"
import style1 from "./FormMessaging.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985c4d50",
  null
  
)

export default component.exports